import { Link } from "react-router-dom";
import { topics } from "@/mocks/dramas";
import { getDramasByTopic } from "@/utils/drama";

const collections = topics.map((topic) => ({
  ...topic,
  count: getDramasByTopic(topic.id).length,
}));

export default function TopicSection() {
  return (
    <section className="w-full bg-background-50 px-4 py-10 md:px-8 md:py-14">
      <div className="mx-auto w-full max-w-6xl">
        <div className="mb-5 flex items-end justify-between gap-4">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-xl font-black text-foreground-950 md:text-2xl">
              <span className="h-5 w-1 rounded-full bg-accent-500" />
              专题推荐
            </h2>
            <p className="mt-1.5 text-xs text-foreground-600 md:text-sm">
              按主题打包好的片单，挑一个开始刷
            </p>
          </div>
          <Link
            to="/category"
            className="flex shrink-0 items-center gap-1 text-xs text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer md:text-sm"
          >
            全部片单
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {collections.map((item) => (
            <Link
              key={item.id}
              to={`/category?topic=${item.id}`}
              className="group relative block h-52 overflow-hidden rounded-lg bg-background-200 md:h-56 cursor-pointer"
            >
              <img
                src={item.cover}
                alt={`${item.name}专题`}
                title={`${item.name} 国产影视专题`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-4 md:p-5">
                <div>
                  <span className="inline-flex items-center rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
                    {item.count} 部作品
                  </span>
                  <h3 className="mt-2 font-heading text-lg font-bold text-background-50 md:text-xl">
                    {item.name}
                  </h3>
                  <p className="mt-1 text-xs text-background-200 md:text-sm">{item.desc}</p>
                </div>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition-colors group-hover:bg-background-50 group-hover:text-foreground-950">
                  <i className="ri-arrow-right-up-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}